import { useEffect, useState } from 'react';

/**
 * The height of a dock floating over the screen's bottom edge, so the page can
 * pad its scroll end by as much and nothing stays hidden under it. 0 while no
 * dock is mounted.
 */
export function useDockClearance() {
  const [dock, setDock] = useState<HTMLElement | null>(null);
  const [clearance, setClearance] = useState(0);

  useEffect(() => {
    if (!dock) return;
    const observer = new ResizeObserver(() => setClearance(dock.offsetHeight));
    observer.observe(dock);
    return () => {
      observer.disconnect();
      setClearance(0);
    };
  }, [dock]);

  return { dockRef: setDock, clearance };
}
